import { computed } from "vue";
import type { DSTitleFieldProps } from "@/src/design_system/form_elements/title_field/types";
import { generateUUID } from "@/src/shared/utils/uuid";

export const useDSTitleFieldErrors = (props: Readonly<Pick<DSTitleFieldProps, "errorMessages">>) => {
  const errorMessageIdPrefix = `ds-title-field-error-${generateUUID()}`;
  const hasErrors = computed(() => !!props.errorMessages?.length);
  const errorMessageIds = computed(() => {
    if (!hasErrors.value) return undefined;

    return props.errorMessages?.map((_, index) => `${errorMessageIdPrefix}-${index}`).join(" ");
  });

  return { errorMessageIdPrefix, errorMessageIds, hasErrors };
};
